export enum SelectedContext {
    TRANSPORT_ORDER = 'TRANSPORT_ORDER',
    TRANSPORT_CAPACITY_ORDER = 'TRANSPORT_CAPACITY_ORDER',
    COMPOUND_VEHICLE = 'COMPOUND_VEHICLE',
    SERVICE_OPTION = 'SERVICE_OPTION',
    SERVICE_ORDER = 'SERVICE_ORDER',
    VDA_SERVICE_ORDER = 'VDA_SERVICE_ORDER',
    VDA_SERVICE_ORDER_RESPONSE = 'VDA_SERVICE_ORDER_RESPONSE',
    VDA_TRANSPORT_CAPACITY_ORDER = 'VDA_TRANSPORT_CAPACITY_ORDER',
    VDA_TRANSPORT_CAPACITY_ORDER_RESPONSE = 'VDA_TRANSPORT_CAPACITY_ORDER_RESPONSE',
    VDA_TRANSPORT_ORDER = 'VDA_TRANSPORT_ORDER',
    VDA_TRANSPORT_ORDER_RESPONSE = 'VDA_TRANSPORT_ORDER_RESPONSE',
    VDA_TRANSPORT_STATUS_REPORTS = 'VDA_TRANSPORT_STATUS_REPORTS',
    VDA_COMPOUND_TRANSPORT_ORDER = 'VDA_COMPOUND_TRANSPORT_ORDER',
}

export enum Environment {
    PROD = 'prod',
    QA = 'qa',
}

export type NaturalLanguageQuery = {
    query: string;
    selectedContext: SelectedContext;
    environment: Environment;
    limit?: number;
};
export type DataItem = Record<string, unknown>;

export type FinishedVehicleQueryResult = {
    queryId: string;
    limitExceeded: boolean;
    items: DataItem[];
};
